import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Icon, { Icons } from '../Icon/Icon';
import './ContextualMenu.scss';

const iconSize = 24;

const ContextualMenu = ({ className, icon, content, onClick, separator }) => {
	return (
		<>
			<div className={classNames('ContextualMenu', className)} onClick={onClick}>
				{icon && <Icon className='icon' type={Icons[icon]} width={iconSize} height={iconSize} />}
				{content && <div className='content'>{typeof content === 'function' ? content() : content}</div>}
			</div>
			{separator && <div className='ContextualMenu-separator'></div>}
		</>
	);
};

ContextualMenu.propTypes = {
	className: PropTypes.string,
	icon: PropTypes.string,
	content: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
	onClick: PropTypes.func,
	separator: PropTypes.bool,
};

export default ContextualMenu;
